import React from 'react'
import {ITextProps} from './text/Text'
import {ITitleProps} from './text/Title'

export type ComponentItem =
    | {component: React.ComponentType<ITextProps>; props: ITextProps}
    | {component: React.ComponentType<ITitleProps>; props: ITitleProps}

type WizComponentFactory = <Props>(component: React.ComponentType<Props>, props: Props) => JSX.Element

export const CreateComponent: WizComponentFactory = (component, props) => {
    return React.createElement(component, props)
}
